// extracted by mini-css-extract-plugin
export default {"trusted":"Trusted_trusted__Y0eCR","trustedBox":"Trusted_trustedBox__7M0nB","trustedBoxes":"Trusted_trustedBoxes__3J76T","orange":"Trusted_orange__KR563"};